import { keyframes } from "styled-components";


export const sizeUp = keyframes`
	0% {
		transform: scale(0.9);
	}
	
	25% {
		transform: scale(1.1);
	}
	
	50% {
		transform: scale(1);
		font-size: 35px;
		opacity: 1;
	} 
	100% {
		font-size: 100em;
		opacity: 0;
	}
`;
